import { TourBagIronDetail } from '@/api/models';
import { headTypeMap, HeadTypeName } from '@/constants';

interface ICreateEmptyTourBagIronDetailProps {
  ironClubId?: number;
  ironClubName?: string;
  headTypeName?: HeadTypeName;
}

export const createEmptyTourBagIronDetail = ({ ironClubId, ironClubName, headTypeName = 'Iron' }: ICreateEmptyTourBagIronDetailProps = {}): TourBagIronDetail => ({
  // SharedModel defaults
  createDate: new Date(),
  modifyDate: new Date(),
  isActive: true,
  modifyUserGuid: '',
  modifyUserName: '',
  createUserGuid: '',
  rowGuid: '',
  tstamp: '',

  // Required fields
  tourBagIronDetailId: 0, // tourBagIronDetailId needs to be 0 to allow for new irons and set irons to be created
  tourBagIronSetId: null,
  tourBagMstrId: -1,
  playerId: 0,
  tourId: 0,
  headTypeId: headTypeMap[headTypeName],
  itemNo: 0,
  headModelId: 0,
  editSource: 'web',
  hand: '',
  ironClubId: ironClubId || 0,
  ironClubName: ironClubName || '',
  playerName: '',
  tourName: '',
  headTypeDescription: headTypeName,
  headModelName: '',
  // headModelAlternateName: '',
  familyId: 0,
  familyName: '',

  // Shaft
  shaftTippingDigit: '',
  shaftTippingFraction: '',
  isShaftLengthFinished: false,
  shaftLengthDigit: '',
  shaftLengthFraction: '',
  shaftPinstamp: '',
  shaftName: '',
  shaftCosmetic: '',

  // Loft & Lie
  loftDigit: '',
  loftFraction: '',
  lieDigit: '',
  lieFraction: '',

  // Swing Weight & Grip
  swingWtPrefixName: '',
  swingWtSuffixName: '',
  gripType: '',
  gripSize: '',
  tape: '',
  rndRib: '',
  logo: '',

  // Optional numeric/string IDs
  shaftLengthDigitId: 0,
  shaftLengthDigitId1: 0,
  shaftLengthFractionId: 0,
  shaftLengthFractionId1: 0,
  shaftTippingFractionId: 0,
  shaftTippingFractionId1: 0,
  loftDigitId: 0,
  loftDigitId1: 0,
  loftFractionId: 0,
  loftFractionId1: 0,
  lieDigitId: 0,
  lieDigitId1: 0,
  lieFractionId: 0,
  lieFractionId1: 0,
  gripSizeId: 0,
  gripTypeId: 0,
  swingWtPrefixId: 0,
  swingWtSuffixId: 0,

  // Notes & Order linkage
  notes: '',
  orderDetailId: 0,
  tourBagMstrRowGuid: '',

  headWeight: null,
  drill: null,
  tipPlug: null,
  glueWeight: null,
  leadTape: null,
  headWeightLocationBackLookupId: null,
  headWeightLocationBackLookupName: '',
  headWeightNumberBackLookupId: null,
  headWeightNumberBackLookupName: '',
});
